import transformHeading from "theme/libs/wordpress/utils/transformHeading";

export default (headingGroup = {}, device = "desktop") => {
    if (device === "mobile" && headingGroup?.customizeMobile && headingGroup?.data?.mobile) {
        return transformHeading(headingGroup?.data?.mobile);
    }
    return transformHeading(headingGroup?.data?.desktop);
};
